// extracted by css-extract-rspack-plugin
export default {"content":"JvxIBn"};